import React, { useEffect } from 'react';

const MobileLogout: React.FC = () => {
  useEffect(() => {
    fetch('/api/useraccount/logout', {
      method: 'GET',
      credentials: 'include',
    })
      .catch(() => {
        // Ignore errors
      })
      .finally(() => {
        window.location.replace('/?utm_source=mobile_app');
      });
  }, []);

  return null;
};

export default MobileLogout;